import React, { useState } from 'react';
import { Container, Checkbox, Slider, LabelInfo, LabelOn, LabelOff } from './switchSell.styled';


interface Props {
    checked?: boolean
    labelOn?: string
    labelOff?: string
    onChange?: (checked: boolean) => void
}

export const Switch: React.FC<Props> = ({ labelOn = "Sell", labelOff = "Sweep", onChange }) => {

    const [isChecked, setChecked] = useState(false)
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked)
    };
    const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation()
        setChecked(!isChecked)
        onChange && onChange(!isChecked)
    };

    return (
        <Container >
            <Checkbox checked={isChecked} onChange={handleChange} />
            <Slider checked={isChecked} onClick={handleSwitchClick} />
            <LabelInfo>
                <LabelOn checked={isChecked}>{labelOn}</LabelOn>
                <LabelOff checked={isChecked}>{labelOff}</LabelOff>
            </LabelInfo>
        </Container>
    )
}
